export default __webpack_public_path__ + "static/media/caret-right.48bbf636.svg";